
import {AfterContentChecked, Directive, ElementRef, Renderer2, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[contentOffset], [webu-content-offset]'
})
export class ContentOffsetDirective implements AfterContentChecked{
    private _hasMovedMainContent = false;
    get hasMovedMainContent(){return this._hasMovedMainContent;}
    public thisElement: Element;
    constructor(
        private elem: ElementRef, 
        private host: ViewContainerRef,
        private renderer: Renderer2
    ){}
    /**
     * Call in AfterContentChecked
     * Why?: The CSS style does not get applied right away, 
     * we need to use the CSS value of SharedNav to add padding to the main content on the page
     * This call will keep looking for the sharedNav and height and pass into 'getAndSetOffsetForContent' for
     * further checks
     */
    ngAfterContentChecked(): void {
        const sharedNav = this.elem?.nativeElement?.parentNode?.querySelector('#gbSharedNav');
        if (sharedNav) {
            const height = window.getComputedStyle(sharedNav).height;
            this.getAndSetOffsetForContent(sharedNav,height);
        }
    }
    /**
     * Varaible checks
     * @argument hasMovedMainConetent: this checks if we have already moved the main content.
     * @argument window.getComputedStyle: ensure that there is a height to the element (no height therefore no element)
     * @param sharedNav:Element for shared nav (must exist)
     * @param height: Give current height of sharedNav
     * 
     * @returns Boolean
     */
    shouldWeMoveContent(sharedNav:Element,height:string): boolean{ 
        return !this.hasMovedMainContent && sharedNav && height != '0px';
    }
    /**
     * @param sharedNav: Element for shared nav (must exist and is checked by 'shouldWeMoveContent')
     * Once complete 'hasMovedMainContent' is true and this method should not be hit again until refresh
     */
    getAndSetOffsetForContent(sharedNav:Element,height:string):void {
        if(this.shouldWeMoveContent(sharedNav,height)){
            this.thisElement = this.host.element.nativeElement;
            this.renderer.setAttribute(this.thisElement,'style',`padding-top: ${height}`);
            this._hasMovedMainContent = true;
        }
    }
    
}